module.exports = __webpack_public_path__ + "img/72.b513d0df.jpg";